var _rect, _path, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropose3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 34,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4584 48.303H24.3702C22.5465 48.303 20.7976 49.0862 19.5081 50.4803C18.2186 51.8743 17.4941 53.7651 17.4941 55.7366C17.4941 57.7081 18.2186 59.5988 19.5081 60.9929C20.7976 62.387 22.5465 63.1701 24.3702 63.1701H56.4584C58.282 63.1701 60.031 62.387 61.3205 60.9929C62.61 59.5988 63.3344 57.7081 63.3344 55.7366C63.3344 53.7651 62.61 51.8743 61.3205 50.4803C60.031 49.0862 58.282 48.303 56.4584 48.303ZM54.1664 38.3916C56.5979 38.3916 58.9298 37.3474 60.6492 35.4886C62.3685 33.6299 63.3344 31.1089 63.3344 28.4802C63.3344 25.8515 62.3685 23.3305 60.6492 21.4718C58.9298 19.613 56.5979 18.5688 54.1664 18.5688C51.7348 18.5688 49.4029 19.613 47.6836 21.4718C45.9642 23.3305 44.9983 25.8515 44.9983 28.4802C44.9983 31.1089 45.9642 33.6299 47.6836 35.4886C49.4029 37.3474 51.7348 38.3916 54.1664 38.3916ZM17.4941 28.4802L27.8082 17.3299L38.1223 28.4802L27.8082 39.104L17.4941 28.4802Z",
    stroke: "url(#paint0_linear_3061_17431)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5,
    cy: 8,
    r: 8,
    fill: "#D50101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_17431",
    x1: 40.4143,
    y1: 17.3299,
    x2: 40.4143,
    y2: 63.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose3);
export default __webpack_public_path__ + "static/media/propose3.0f7ac3bb6504e632afce350e922d1484.svg";
export { ForwardRef as ReactComponent };